/* Section: Products — original: section#products.section.pr-section
   The "Product image sliders" IIFE from the adensalt.com section scripts (section-scripts-b.js),
   unchanged. No endpoints, no globals. Keys off .pr-slider / .pr-track / .pr-slide / .pr-dot /
   .pr-arrow[data-dir] / .pr-live emitted by parts/sections/products.php. The "Get my price"
   card buttons (.prod-card-cta[data-salt]) are wired by 00-utils.js (chrome owner). */
/* ---------- Product image sliders ---------- */
(function(){
  /* One slider per product card: translateX track, prev/next and bar buttons, arrow keys while the
     slider has focus, and a horizontal swipe/drag (pan-y keeps vertical page scroll on touch).
     Loops at both ends. No autoplay. Reduced motion switches with no transition (CSS drops it).
     A single-slide slider becomes a plain image: controls hidden, no keys, no swipe. */
  var sliders = document.querySelectorAll('.pr-slider');
  if(!sliders.length) return;
  sliders.forEach(function(root){
    var track = root.querySelector('.pr-track');
    var slides = root.querySelectorAll('.pr-slide');
    var dots = root.querySelectorAll('.pr-dot');
    var live = root.querySelector('.pr-live');
    var n = slides.length;
    if(!track) return;
    if(n < 2){
      root.classList.add('is-single');
      root.removeAttribute('tabindex');
      root.removeAttribute('aria-roledescription');
      return;
    }
    var index = 0;
    function go(i, announce){
      index = (i % n + n) % n;
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      slides.forEach(function(sl, k){
        if(k === index) sl.removeAttribute('aria-hidden'); else sl.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function(d, k){
        if(k === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if(announce && live) live.textContent = 'Image ' + (index + 1) + ' of ' + n;
    }
    root.querySelectorAll('.pr-arrow').forEach(function(btn){
      btn.addEventListener('click', function(){ go(index + Number(btn.getAttribute('data-dir')), true); });
    });
    dots.forEach(function(d, k){ d.addEventListener('click', function(){ go(k, true); }); });
    root.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); go(index - 1, true); }
      else if(e.key === 'ArrowRight'){ e.preventDefault(); go(index + 1, true); }
    });
    /* Swipe / drag: decide direction after 8px; horizontal drags move the track, vertical ones are left to the page */
    var startX = 0, startY = 0, dx = 0, pid = null, mode = '';
    track.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'mouse' && e.button !== 0) return;
      pid = e.pointerId; startX = e.clientX; startY = e.clientY; dx = 0; mode = '';
      if(e.pointerType === 'mouse') e.preventDefault();
    });
    track.addEventListener('pointermove', function(e){
      if(e.pointerId !== pid) return;
      var mx = e.clientX - startX, my = e.clientY - startY;
      if(!mode){
        if(Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        mode = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if(mode === 'x'){
          track.classList.add('is-dragging');
          try{ track.setPointerCapture(pid); }catch(err){}
        }
      }
      if(mode !== 'x') return;
      dx = mx;
      track.style.transform = 'translateX(calc(' + (-100 * index) + '% + ' + dx + 'px))';
    });
    function end(e){
      if(e.pointerId !== pid) return;
      pid = null;
      if(mode !== 'x'){ mode = ''; return; }
      mode = '';
      track.classList.remove('is-dragging');
      var threshold = Math.min(60, root.clientWidth * 0.15);
      if(dx <= -threshold) go(index + 1, true);
      else if(dx >= threshold) go(index - 1, true);
      else go(index, false);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  });
})();
